import Vue from 'vue'
import Vuex from 'vuex'
import { authApi } from '@/utils/api'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 管理员信息
    adminInfo: JSON.parse(localStorage.getItem('admin_info')) || null,
    // 登录状态
    isLoggedIn: !!localStorage.getItem('admin_token'),
    // 侧边栏折叠状态
    sidebarCollapsed: false
  },
  
  mutations: {
    // 设置管理员信息
    SET_ADMIN_INFO(state, adminInfo) {
      state.adminInfo = adminInfo
      localStorage.setItem('admin_info', JSON.stringify(adminInfo))
    },
    
    // 设置登录状态
    SET_LOGIN_STATUS(state, status) {
      state.isLoggedIn = status
    },
    
    // 清除登录信息
    CLEAR_LOGIN_INFO(state) {
      state.adminInfo = null
      state.isLoggedIn = false
      localStorage.removeItem('admin_token')
      localStorage.removeItem('admin_info')
    },
    
    // 切换侧边栏状态
    TOGGLE_SIDEBAR(state) {
      state.sidebarCollapsed = !state.sidebarCollapsed
    }
  },
  
  actions: {
    // 登录
    async login({ commit }, { username, password }) {
      try {
        const response = await authApi.adminLogin({
          username: username,
          password: password
        })
        
        if (response.code === 200) {
          const { token } = response.data
          const userInfo = response.data.userInfo
          const adminInfo = userInfo
          
          localStorage.setItem('admin_token', token)
          commit('SET_ADMIN_INFO', adminInfo)
          commit('SET_LOGIN_STATUS', true)
          
          return { token, adminInfo }
        } else {
          throw new Error(response.msg || '登录失败')
        }
      } catch (error) {
        throw new Error(error.message || '登录失败')
      }
    },
    
    // 登出
    logout({ commit }) {
      commit('CLEAR_LOGIN_INFO')
    }
  },
  
  getters: {
    isLoggedIn: state => state.isLoggedIn,
    adminInfo: state => state.adminInfo,
    sidebarCollapsed: state => state.sidebarCollapsed,
    // 权限相关getter
    userType: state => state.adminInfo ? state.adminInfo.userType : null,
    isSuperAdmin: state => state.adminInfo && state.adminInfo.userType === 1,
    isProjectManager: state => state.adminInfo && state.adminInfo.userType === 2,
    isWorker: state => state.adminInfo && state.adminInfo.userType === 3
  }
})